module.exports = __webpack_public_path__ + "static/media/generic-preview.8c116be4.png";